import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SectionIntroProps {
  eyebrow?: ReactNode;
  title: ReactNode;
  intro?: ReactNode;
  /** Use on dark (navy/ink) backgrounds. */
  inverted?: boolean;
  align?: 'left' | 'center';
  as?: 'h1' | 'h2';
  id?: string;
  className?: string;
  size?: 'lg' | 'md';
}

/** Eyebrow + headline + intro, with a controlled measure so headlines never sprawl. */
export function SectionIntro({ eyebrow, title, intro, inverted, align = 'left', as: As = 'h2', id, className, size = 'lg' }: SectionIntroProps) {
  return (
    <div className={cn(align === 'center' && 'mx-auto text-center', 'max-w-[680px]', className)}>
      {eyebrow && (
        <p className={cn('eyebrow flex items-center gap-3', align === 'center' && 'justify-center', inverted ? 'text-steel' : 'text-accent-dark')}>
          <span aria-hidden className={cn('h-px w-8', inverted ? 'bg-steel/60' : 'bg-accent')} />
          {eyebrow}
        </p>
      )}
      <As id={id} className={cn(size === 'lg' ? 'display-lg' : 'display-md', 'mt-4', inverted ? 'text-white' : 'text-primary')}>
        {title}
      </As>
      {intro && <p className={cn('mt-5 text-[16.5px] leading-[1.7]', inverted ? 'text-steel' : 'text-muted')}>{intro}</p>}
    </div>
  );
}
